__turbopack_context__.v({
  "aboveFoldTag": "f4vHuq_aboveFoldTag",
  "affectedElements": "f4vHuq_affectedElements",
  "categoryLabel": "f4vHuq_categoryLabel",
  "container": "f4vHuq_container",
  "content": "f4vHuq_content",
  "critical": "f4vHuq_critical",
  "description": "f4vHuq_description",
  "effortTag": "f4vHuq_effortTag",
  "elementLabel": "f4vHuq_elementLabel",
  "elementTag": "f4vHuq_elementTag",
  "elementTags": "f4vHuq_elementTags",
  "evidenceTags": "f4vHuq_evidenceTags",
  "expandIcon": "f4vHuq_expandIcon",
  "findingContent": "f4vHuq_findingContent",
  "findingDescription": "f4vHuq_findingDescription",
  "findingHeader": "f4vHuq_findingHeader",
  "findingItem": "f4vHuq_findingItem",
  "findingTitle": "f4vHuq_findingTitle",
  "findingsList": "f4vHuq_findingsList",
  "header": "f4vHuq_header",
  "headerLeft": "f4vHuq_headerLeft",
  "headerStats": "f4vHuq_headerStats",
  "headerText": "f4vHuq_headerText",
  "high": "f4vHuq_high",
  "icon": "f4vHuq_icon",
  "issueCount": "f4vHuq_issueCount",
  "low": "f4vHuq_low",
  "medium": "f4vHuq_medium",
  "moreElements": "f4vHuq_moreElements",
  "recommendation": "f4vHuq_recommendation",
  "recommendationLabel": "f4vHuq_recommendationLabel",
  "recommendationText": "f4vHuq_recommendationText",
  "screenshotCaption": "f4vHuq_screenshotCaption",
  "screenshotCrop": "f4vHuq_screenshotCrop",
  "screenshotFrame": "f4vHuq_screenshotFrame",
  "screenshotImage": "f4vHuq_screenshotImage",
  "severityIndicator": "f4vHuq_severityIndicator",
  "severityPill": "f4vHuq_severityPill",
  "severityPills": "f4vHuq_severityPills",
  "severityTag": "f4vHuq_severityTag",
});
